import React from 'react';
import {
  Datagrid,
  List,
  TextField,
} from 'react-admin';

export const CategoriesList = () => {
    return (
        <List>
            <Datagrid rowClick="edit">
                <TextField source="name" label="Name" />
                <TextField source="code" label="Code" />
            </Datagrid>
        </List>
    );
}
